define([
	"dojo/_base/declare",
	"csi/action/AggregateBaseController"
], function(declare,AggregateBaseController) {

	return declare(AggregateBaseController, {
		preProcess: function() {
			// summary: make sure existing aggregated nodes are in the cache before continuing to popup dialog
			if (this.refNode) {
				this.widget.highlight(this.refNode, false, true);
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * populate m_bRequireOne so that it would impact the table accordingly
		 */
		getFormData() {
			const fd = this.inherited(arguments);
			const { m_action: { heading } } = this;

			if (heading) {
				// heading wouldn't be available in the case of reverse aggregations
				fd.m_bRequireOne = heading.m_bRequired;
			}

			return fd;
		},

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			// summary: when selecting rows for table (refNode is null), entire page will be re-queried rather than just new ones
			return this.refNode ? this.inherited(arguments) : null;
		},

		postProcess: function(/*Boolean*/bStatus) {
			// summary: post processing for action
			if (this.refNode) {
				this.widget.highlight(this.refNode, true, true);
			}

			this.inherited(arguments);
		},

		postProcessSuccess: function() {
			// summary: refresh display of node referencing new element(s) unless reverse aggregation;
			// assumption is that if configured PostAction returns deferred object then it will override
			// this refresh
			var	dfd = this.inherited(arguments);
			
			if (!dfd) {
				var w = this.widget;
				var refNode = this.refNode;
				if (refNode && !this.m_action.bReverse && !w.isNewActionsButton(refNode)) {
					// refresh single node
					dfd = w.redrawNode(refNode);
				} else {
					// refresh view
					dfd = w.refreshWidget();
				}
			}

			return dfd;
		}
	});
});